import { Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

// taken from https://gist.github.com/ahmeti/5ca97ec41f6a48ef699ee6606560d1f7

@Directive({
    selector: '[lib-numeric]',
    standalone: false
})
export class NumericDirective implements OnChanges {
    @Input() decimals: number = 0;

    private oldValue: string = '';

    constructor(private el: ElementRef<HTMLInputElement>) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['decimals']) {
            this.el.nativeElement.setAttribute('pattern', this.getRegex(changes['decimals'].currentValue))
        }
    }

    private getRegex(decimals: number): string {
        return `^-?\\d*\\.?\\d{0,${Math.max(decimals, 0)}}$`;
    }

    private check(value: string): boolean {
        return !!String(value).match(new RegExp(this.getRegex(this.decimals)));
    }

    private run(currentValue: string): void {
        if (currentValue !== '' && !this.check(currentValue)) {
            this.el.nativeElement.value = this.oldValue;
            this.el.nativeElement.dispatchEvent(new InputEvent('input', {
                view: window,
                bubbles: true,
                cancelable: true,
                data: '',
                inputType: 'deleteContentBackward'
            }));
        }
        else
            this.oldValue = currentValue;
    }

    @HostListener('blur', ['$event'])
    onBlur(_event: Event): void {
        if (this.el.nativeElement.value.match(/^-?\.?$/))
            this.el.nativeElement.value = this.oldValue;
    }

    @HostListener('input', ['$event'])
    onInput(_event: Event): void {
        this.run(this.el.nativeElement.value);
    }

    @HostListener('focus', ['$event'])
    onFocus(_event: Event): void {
        this.oldValue = this.el.nativeElement.value;
    }
}
